// extracted by mini-css-extract-plugin
export var alignCenter = "_81-d";
export var bannerShown = "_81-6";
export var buttonContent = "_81-0";
export var cardList = "_81-1";
export var centerContent = "_81-2";
export var chevron = "_81-3";
export var closePanelButton = "_81-k";
export var conversationContextContainer = "_81-l";
export var conversationDetailContainer = "_81-4";
export var detailWrapper = "_81-7";
export var dropdownButton = "_81-e";
export var dropdownTitle = "_81-9";
export var fullHeight = "_81-5";
export var hidden = "_81-a";
export var icon = "_81-b";
export var mergeSuggestionWrapper = "_81-m";
export var panel = "_81-i";
export var portalButtonsWrapper = "_81-c";
export var right = "_81-j";
export var tableSummaryContainer = "_81-8";
export var tableSummaryHeader = "_81-g";
export var threeDotsButton = "_81-f";
export var wide = "_81-h";